import { graphql } from 'gatsby'
import React from 'react'
import { Helmet } from 'react-helmet'
import showdown from 'showdown'
import DivisorLine from '../components/DivisorLine'
import HubspotForm from '../components/HubspotForm'
import TemplateWrapper2 from '../components/Layout2'
import MyMapComponent from '../components/MyMapComponent'
import TestimonialsRoll from '../components/TestimonialsRoll'
import { getImage } from '../utils';

const converter = new showdown.Converter();

export const ContactsPageTemplate = ({
    lat,
    lng,
    address,
    profile,
    profile2,
    isPreview = false
}) => {
    return (
        <div
            className="container-fluid px-0">
            <DivisorLine />
            <div className="bg-light">
                <div className="container py-5">
                    <div className="row">
                        <div className="col-md-7 col-lg-6 mb-5 mb-md-0 px-3 px-lg-5">
                            <MyMapComponent
                                lat={lat}
                                lng={lng}
                                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=AIzaSyB9ZJ2gzW2kLXBFZZJdOal0G_T9mHxTpcY&libraries=geometry,drawing,places`}
                                loadingElement={<div style={{ height: `100%` }} />}
                                containerElement={<div style={{ height: `400px` }} />}
                                mapElement={<div style={{ height: `100%` }} />}
                                address={address} />
                        </div>
                        <div className="col-md-5 col-lg-6 px-3 px-lg-5">
                            <HubspotForm />
                        </div>
                    </div>
                </div>
            </div>
            <div className="container py-5">
                {/* PROFILE 1 */}
                <div className="row">
                    <div className="col-md-6 col-lg-4 offset-lg-2 d-flex align-items-center">
                        <img
                            src={profile.image.image}
                            alt={profile.image.alt}
                            className="img-fluid mx-auto mx-md-0" />
                    </div>
                    <div className="col-md-6 col-lg-4 mt-4 mt-md-0 d-flex flex-column justify-content-center align-items-center align-items-md-start">
                        <h4 className="font-weight-bold mb-0">
                            {profile.name}
                        </h4>
                        <span className="font-weight-bold text-muted mb-1">{profile.position}</span>
                        <DivisorLine
                            style={{
                                height: "10px",
                                backgroundSize: "contain"
                            }} />
                        <div className="d-flex align-items-center mt-4">
                            <img
                                src="/img/bdz-phone.png"
                                alt="sd"
                                className="img-fluid mr-3 mr-md-5"
                                style={{ width: "20px", height: "20px" }} />
                            <span className="font-weight-bold text-muted">{profile.phone}</span>
                        </div>
                        <div className="d-flex align-items-center mt-3">
                            <img
                                src="/img/bdz-email.png"
                                alt="sd"
                                className="img-fluid mr-3 mr-md-5"
                                style={{ width: "25px", height: "20px" }} />
                            <span className="font-weight-bold text-muted">{profile.email}</span>
                        </div>
                    </div>
                </div>

                {/* PROFILE 2 */}
                <div className="row mt-5">
                    <div className="order-2 order-md-1 col-md-6 col-lg-4 offset-lg-2 mt-4 mt-md-0 d-flex flex-column justify-content-center align-items-center align-items-md-start">
                        <h4 className="font-weight-bold mb-0">
                            {profile2.name}
                        </h4>
                        <span className="font-weight-bold text-muted mb-1">{profile2.position}</span>
                        <DivisorLine
                            style={{
                                height: "10px",
                                backgroundSize: "contain"
                            }} />
                        <div className="d-flex align-items-center mt-4">
                            <img
                                src="/img/bdz-phone.png"
                                alt="sd"
                                className="img-fluid mr-3 mr-md-5"
                                style={{ width: "20px", height: "20px" }} />
                            <span className="font-weight-bold text-muted">{profile2.phone}</span>
                        </div>
                        <div className="d-flex align-items-center mt-3">
                            <img
                                src="/img/bdz-email.png"
                                alt="sd"
                                className="img-fluid mr-3 mr-md-5"
                                style={{ width: "25px", height: "20px" }} />
                            <span className="font-weight-bold text-muted">{profile2.email}</span>
                        </div>
                    </div>
                    <div className="order-1 order-md-2 col-md-6 col-lg-4 d-flex align-items-center">
                        <img
                            src={profile2.image.image}
                            alt={profile2.image.alt}
                            className="img-fluid mx-auto mx-md-0" />
                    </div>
                </div>
            </div>
            {
                !isPreview && (
                    <TestimonialsRoll />
                )
            }
        </div>
    )
}

const ContactsPage = ({
    location,
    data
}) => {
    const {
        lat,
        lng,
        address,
        profile: _profile,
        profile2: _profile2
    } = data.markdownRemark.frontmatter;

    const profile = {
        ..._profile,
        image: {
            ..._profile.image,
            image: getImage(_profile.image)
        }
    }

    const profile2 = {
        ..._profile2,
        image: {
            ..._profile2.image,
            image: getImage(_profile2.image)
        }
    }

    return (
        <TemplateWrapper2
            location={location}>
            <>
                <Helmet titleTemplate="%s">
                    <title>
                        Contáctanos- Constructora Berdez
                    </title>
                    <meta
                        name="description"
                        content="Estamos para ayudarte y asesorarte en la compra de tu casa nueva. Buscamos el mejor proyecto de vivienda sobre planos o terminado que se adapte a ti."
                    />
                </Helmet>
                <ContactsPageTemplate
                    address={address}
                    profile={profile}
                    profile2={profile2}
                    lat={lat}
                    lng={lng}
                />
            </>
        </TemplateWrapper2>
    )
}

export default ContactsPage;

export const pageQuery = graphql`
  query Contacts {
    markdownRemark(frontmatter: { templateKey: { eq: "contacts" } }) {
      frontmatter {
        email
        phone
        address
        lat 
        lng
        profile {
            image {
                image {
                    childImageSharp {
                        fluid {
                            ...GatsbyImageSharpFluid
                        }
                    }
                    publicURL
                }
                alt
            }
            name
            phone
            email
            position
        }
        profile2 {
            image {
                image {
                    childImageSharp {
                        fluid {
                            ...GatsbyImageSharpFluid
                        }
                    }
                    publicURL
                }
                alt
            }
            name
            phone
            email
            position
        }
        networks { 
            facebook
            instagram
            twitter
            youtube
        }
      }
    }
  }
`